import { useEffect, useState } from "react";
import axios from "axios";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const PdfViewer = ({ base, v = "", side, jump }) => {
  const [pages, setPages] = useState(null);
  const [n, setN] = useState(jump?.n || 0);
  const [err, setErr] = useState("");
  useEffect(() => { if (jump) setN(jump.n); }, [jump]);
  const q = v ? `v=${encodeURIComponent(v)}` : "";
  useEffect(() => {
    let t;
    setPages(null);
    const poll = () => axios.get(`${base}/pdf/meta`, { withCredentials: true }).then((r) => (r.status === 202 ? (t = setTimeout(poll, 5000)) : setPages(r.data.pages))).catch((e) => { setErr(e.response?.data?.detail || ""); setPages(0); });
    poll();
    return () => clearTimeout(t);
  }, [base, v]);
  useEffect(() => {
    const k = (e) => {
      if (["INPUT", "TEXTAREA"].includes(e.target?.tagName)) return;
      if (e.key === "ArrowRight") setN((x) => Math.min(x + 1, (pages || 1) - 1));
      if (e.key === "ArrowLeft") setN((x) => Math.max(x - 1, 0));
    };
    window.addEventListener("keydown", k);
    return () => window.removeEventListener("keydown", k);
  }, [pages]);
  if (pages === null) return <div data-testid="preview-pdf-preparing" className="h-[600px] flex items-center justify-center text-stone-400 text-sm">Preparing the PDF… this takes about a minute for large kits</div>;
  if (!pages) return <div data-testid="preview-pdf-error" className={`text-sm ${err ? "text-red-600" : "text-stone-400"}`}>{err || "PDF not available"}</div>;
  const page = Math.min(n, pages - 1);
  const btn = "p-2 rounded-full border border-stone-300 bg-white hover:bg-stone-100 disabled:opacity-30";
  return (
    <div data-testid="preview-pdf">
      <div className={side ? "grid lg:grid-cols-[1fr_380px] gap-8 items-start" : ""}>
        <div>
          <div className="flex items-center justify-center gap-4">
            <button data-testid="preview-pdf-prev" className={btn} disabled={!page} onClick={() => setN(page - 1)}><ChevronLeft size={18} /></button>
            <img data-testid="preview-pdf-page" key={`${page}-${v}`} src={`${base}/pdf/page/${page}${q ? `?${q}` : ""}`} alt={`Page ${page + 1}`} className="h-[640px] max-w-full object-contain bg-white shadow-xl border border-stone-200" />
            <button data-testid="preview-pdf-next" className={btn} disabled={page >= pages - 1} onClick={() => setN(page + 1)}><ChevronRight size={18} /></button>
          </div>
          <div data-testid="preview-pdf-counter" className="text-center text-xs text-stone-500 mt-3">Page {page + 1} of {pages} · use ← → keys</div>
        </div>
        {side && side(page)}
      </div>
      <div className="mt-4 flex gap-2 overflow-x-auto pb-2">
        {Array.from({ length: pages }, (_, i) => (
          <button key={i} data-testid={`preview-pdf-thumb-${i}`} onClick={() => setN(i)} className={`shrink-0 border-2 ${i === page ? "border-[#C9A847]" : "border-transparent"}`}>
            <img loading="lazy" src={`${base}/pdf/page/${i}?thumb=1${q ? `&${q}` : ""}`} alt="" className="h-24 bg-white" />
          </button>
        ))}
      </div>
    </div>
  );
};
